/**
 * Open a URL in a new tab. If the browser blocks the popup (e.g. when the
 * app is loaded inside a sandboxed iframe like the Emergent preview), fall
 * back to navigating the top-level window.
 */
export function openExternal(url) {
    if (!url) return;
    try {
        const w = window.open(url, "_blank", "noopener,noreferrer");
        if (w && !w.closed) return;
    } catch (_) {
        /* fall through */
    }
    try {
        if (window.top && window.top !== window.self) {
            window.top.location.href = url;
            return;
        }
    } catch (_) {
        /* cross-origin block */
    }
    window.location.href = url;
}

/** Convenience to use as an onClick that prevents the default <a> behavior. */
export function externalLinkHandler(url) {
    return (e) => {
        e.preventDefault();
        e.stopPropagation();
        openExternal(url);
    };
}
